import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

// ============================================================================
// PAYLOAD MAPPING
// ============================================================================

export function mapInputToPayload(input: ParsedValues): APIPayload {
  return {
    title: input.title,
    L: input.length,
    W: input.tributaryWidth,
    wadd: input.addedWeight,
    supports: input.supports,
    orientation: input.orientation,
    isectionType: input.sectionType,
    isection: input.sectionName,
    idirection: input.direction,
    fdy: input.fdy,
    fdu: input.fdu,
    shearpl: input.doublePlate,
    irestrained: input.restrained,
    lat0bot: input.bottomFlange,
    lat0top: input.topFlange,
    P: input.axialLoad,
    Pa: input.pressureHistory,
    td: input.timeHistory,
    d0: input.u0,
    v0: input.v0
  };
}

const { analyze, analyzeCancellable: analyzeSteelElementCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>('/iSteelElement/', mapInputToPayload, { retry: 2, timeout: 15000 });

export { analyze, analyzeSteelElementCancellable };
